import React, { useState } from 'react';
import { Card, Form, Button, Alert, Table, Typography, Input, Upload, Modal, Space, Spin } from 'antd';
import { PictureOutlined, ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Text } = Typography;

// Ícone personalizado de estrelas de 4 pontas
const SparklesIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#7c3aed" style={{ marginRight: 8, position: 'relative', top: '2px' }}>
    {/* Estrela grande central de 4 pontas */}
    <path d="M12 2L15 9.5L22.5 12L15 14.5L12 22L9 14.5L1.5 12L9 9.5L12 2Z" />
    {/* Estrela pequena no canto superior esquerdo */}
    <path d="M4 1L5 3.5L7.5 4L5 4.5L4 7L3 4.5L0.5 4L3 3.5L4 1Z" />
    {/* Estrela pequena no canto inferior direito */}
    <path d="M19 16L20 18.5L22.5 19L20 19.5L19 22L18 19.5L15.5 19L18 18.5L19 16Z" />
  </svg>
);

const antIcon = <LoadingOutlined style={{ fontSize: 24, color: '#7c3aed' }} spin />;

const MessageStep = ({
  isGeneratingTemplate,
  handleGenerateTemplate,
  campaignProcessed,
  showAiPrompt,
  setShowAiPrompt,
  generatedMessages,
  form,
  previewMode
}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  const getFileList = () => {
    return form.getFieldValue('fileList') || [];
  };

  const handlePreview = async file => {
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewVisible(true);
  };

  const handleUploadChange = ({ fileList }) => {
    form.setFieldsValue({ fileList });
  };

  const uploadButton = (
    <div>
      <PictureOutlined />
      <div style={{ marginTop: 8 }}>Adicionar Imagem</div>
    </div>
  );

  return (
    <Card>
      <div style={{ marginBottom: 16 }}>
        <Button
          type="default"
          icon={<SparklesIcon />}
          onClick={() => setShowAiPrompt(!showAiPrompt)}
          disabled={campaignProcessed}
        >
          {showAiPrompt ? 'Esconder Prompt' : 'Editar Prompt IA'}
        </Button>
      </div>

      {showAiPrompt && (
        <Form.Item
          name="aiPromptTemplate"
          label="Template de Prompt IA"
          extra="Edite este prompt para personalizar como a IA gera as mensagens."
        >
          <div style={{ position: 'relative' }}>
            <TextArea
              rows={4}
              placeholder="Prompt personalizado para a geração de mensagens pela IA"
              disabled={campaignProcessed}
              style={{ paddingRight: '32px' }}
            />
            <Button
              type="link"
              icon={<ArrowRightOutlined />}
              onClick={handleGenerateTemplate}
              loading={isGeneratingTemplate}
              disabled={campaignProcessed}
              style={{
                position: 'absolute',
                right: 5,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#1890ff',
                padding: '4px',
                height: 'auto',
                minWidth: 'auto',
                fontSize: '16px',
                zIndex: 1,
                lineHeight: 1
              }}
            />
          </div>
        </Form.Item>
      )}

      {isGeneratingTemplate && (
        <Text type="secondary" style={{ marginLeft: 10 }}>
          Gerando modelo de mensagem ...
        </Text>
      )}

      <Form.Item
        name="fileList"
        label="Imagens para a Campanha"
        extra="Você pode adicionar até 5 imagens que serão enviadas junto com as mensagens da campanha."
        valuePropName="fileList"
        getValueFromEvent={e => e && e.fileList}
      >
        <Upload
          listType="picture-card"
          fileList={getFileList()}
          onPreview={handlePreview}
          onChange={handleUploadChange}
          beforeUpload={() => false}
          disabled={campaignProcessed}
          accept="image/*"
          multiple
        >
          {getFileList().length >= 5 ? null : uploadButton}
        </Upload>
      </Form.Item>

      <Modal
        open={previewVisible}
        title="Prévia da Imagem"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal>

      {campaignProcessed && (
        <Alert
          message="Campanha já processada"
          description="A campanha já foi processada. O modelo de mensagem não pode mais ser alterado."
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {isGeneratingTemplate && generatedMessages.length === 0 && (
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 0' }}>
            <Spin indicator={antIcon} />
            <Text style={{ marginTop: 16, fontSize: '16px', color: '#7c3aed' }}>
              Gerando prévia de mensagens com inteligência artificial...
            </Text>
            <Text type="secondary" style={{ marginTop: 8 }}>
              Isso pode levar alguns segundos. As mensagens geradas aparecerão aqui.
            </Text>
          </div>
        </div>
      )}

      {generatedMessages.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px' }}>Prévia de Mensagens:</h5>

          <Table
            dataSource={generatedMessages}
            rowKey="id"
            columns={[
              {
                title: 'Cliente',
                dataIndex: 'customerName',
                key: 'customerName',
              },
              {
                title: 'Último Pedido',
                dataIndex: 'lastPurchase',
                key: 'lastPurchase',
              },
              {
                title: 'Produto Favorito',
                dataIndex: 'favoriteProduct',
                key: 'favoriteProduct',
              },
              {
                title: 'Mensagem',
                dataIndex: 'message',
                key: 'message',
              },
            ]}
            pagination={false}
            size="small"
          />
        </div>
      )}
    </Card>
  );
};

export default MessageStep; 